import React from 'react';
import Header from '../Landingpage/Header';
import MainContent from './MainContent';
import Footer from '../../Company/About/Footer';
import EnergyVisualizer from '../Questions/ER';
import Navbar from '../../Company/About/Navbar';

function ThankYouPage() {
  return (
    <div className="min-h-screen w-full bg-background flex flex-col">
      <Navbar />
      <MainContent />
      <Footer />
    </div>
  );
}

export default ThankYouPage;